import React, { useEffect } from 'react'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { nowOnClinicTimezone } from '@/v2/utils/convert'
import useDetectDevice from '@/v2/hooks/useDetectDevice'
import Monthly from './Monthly'
import Daily from './PeriodOfTime/Daily'
import Weekly from './PeriodOfTime/Weekly'

const today = format(nowOnClinicTimezone(), 'yyyy-MM-dd')

const Calendar = () => {
  const navigate = useNavigate()
  const { view = 'day', date = today } = useParams()
  const { isMobile } = useDetectDevice()

  // Redirect mobile users to daily view if they try to access week/month views
  useEffect(() => {
    if (isMobile && (view === 'week' || view === 'month')) {
      navigate(`/v2/calendar/day/${date}`, { replace: true })
    }
  }, [isMobile, view, date, navigate])

  // when date comes as '2022-9-01', adjust to '2022-09-01'
  useEffect(() => {
    if (/[0-9]{4}-[0-9]{1}-[0-9]{2}/.test(date)) {
      const fixedDate = date.slice(0, 5) + '0' + date.slice(5)
      navigate(`/v2/calendar/${view}/${fixedDate}`, { replace: true })
    }
  }, [date, view, navigate])

  // Don't render if we're redirecting
  if (/[0-9]{4}-[0-9]{1}-[0-9]{2}/.test(date)) {
    return null
  }

  // On mobile, always show daily view
  if (isMobile) {
    return <Daily />
  }

  return view === 'month' ? (
    <Monthly date={date} />
  ) : view === 'day' ? (
    <Daily />
  ) : (
    <Weekly />
  )
}

export default Calendar
